/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import { getSiteDomain, inViewForReact } from 'utils/common';
import LazyLoad from 'react-lazy-load';
import classNames from 'classnames';
import Link from 'components/Link';
import throttle from 'lodash.throttle';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class IFrameWdt extends React.Component {
  constructor() {
    super();
    this.state = {
      // eslint-disable-next-line no-script-url
      stateSrc: '',
    };
    this.scrollIframeInViewListener = throttle(
      () => this.scrollInViewListener(),
      100,
    );
  }

  componentDidMount() {
    window.addEventListener('blur', this.onBlur);
    window.addEventListener('scroll', this.scrollIframeInViewListener);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('scroll', this.scrollIframeInViewListener);
  }

  scrollInViewListener = () => {
    if (this.iframeRef && inViewForReact(this.iframeRef, 0, true)) {
      const { sendGA } = this.props;
      if (typeof sendGA === 'function') {
        sendGA('scrollInView');
        window.removeEventListener('scroll', this.scrollIframeInViewListener);
      }
    }
  };

  /**
   * On click of coronavrius widget iframe
   */
  onBlur = () => {
    if (
      document &&
      document.activeElement &&
      document.activeElement.nodeName.toLowerCase() === 'iframe' &&
      this.iframeRef &&
      this.iframeRef === document.activeElement
    ) {
      const { sendGA } = this.props;
      if (typeof sendGA === 'function') {
        sendGA('click');
      }
    }
  };

  getIframeHtml = () => {
    const { id, useIframeIntersectionObserver, border } = this.props;
    const styleObj = {
      width: '100%',
      ...(this.props.margin && { margin: this.props.margin }),
    };

    const iframeSrc =
      this.props.dataUrl ||
      this.props.wu ||
      `${getSiteDomain()}${this.props.src}`;

    if (useIframeIntersectionObserver) {
      return (
        <>
          <iframe
            ref={ref => {
              this.iframeRef = ref;
            }}
            id={id}
            src={this.state.stateSrc}
            title={this.props.name}
            height={this.props.height}
            marginWidth="0"
            marginHeight="0"
            frameBorder="0"
            scrolling="no"
            align="center"
            style={
              border ? { ...styleObj, border: ' 1px solid' } : { ...styleObj }
            }
          />
          <InViewObserver
            inViewCallback={() => {
              this.setState({ stateSrc: iframeSrc });
            }}
            viewMargin="1000px 0px 1000px 0px"
          >
            <></>
          </InViewObserver>
        </>
      );
    }
    if (this.props.lazyload !== '1') {
      return (
        <iframe
          ref={ref => {
            this.iframeRef = ref;
          }}
          id={id}
          src={iframeSrc}
          loading={this.props.lazy ? 'lazy' : 'eager'}
          title={this.props.name}
          height={this.props.height}
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          scrolling="no"
          align="center"
          style={
            border ? { ...styleObj, border: ' 1px solid' } : { ...styleObj }
          }
        />
      );
    }
    return (
      <>
        <iframe
          ref={ref => {
            this.iframeRef = ref;
          }}
          src={this.state.stateSrc}
          id={this.props.id || ''}
          title={this.props.name}
          height={this.props.height}
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          scrolling="no"
          align="center"
          style={{
            width: '100%',
          }}
        />

        <LazyLoad
          debounce={false}
          onContentVisible={() => {
            this.setState({
              stateSrc: `${
                this.props.src.indexOf('http') === -1 ? getSiteDomain() : ''
              }${this.props.src}`,
            });
          }}
          height="1px"
        >
          <></>
        </LazyLoad>
      </>
    );
  };

  render() {
    let headingGa = null;
    if (this.props.id === 'navbharattimes') {
      headingGa = `NBT-Actions#NBT_Click`;
    }
    if (this.props.id === 'medaltally') {
      headingGa = `click-medaltally${this.props.path && `#${this.props.path}`}`;
    }
    return (
      <React.Fragment>
        <InViewObserver
          inViewCallback={() => {
            if (
              typeof this.props?.ga4Type !== 'undefined' &&
              this.props?.ga4Type !== ''
            ) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: this.props?.ga4Type,
                category: this.props?.ga4Category,
              });
            }
          }}
        >
          <div
            className={classNames({
              [this.props.className]: true,
              coronacountervisit:
                this.props.item &&
                this.props.item.id === 'corona_counter_widget',
              wimbledonifrmwdgt:
                this.props.id && this.props.id === 'wimbledoniframe',
            })}
          >
            {this.props.name && (
              <h2>
                {this.props.path && (
                  <span>
                    <Link
                      data-newga={headingGa}
                      to={this.props.path}
                      target={
                        this.props.target === '_blank' ? this.props.target : ''
                      }
                      ga4Data={
                        this.props?.ga4Type && [
                          {
                            event: 'user_click',
                            type: `${this.props?.ga4Type}`,
                            label: `${this.props?.name.toLowerCase()}`,
                            category: `${'section_heading_click'}`,
                          },
                        ]
                      }
                    >
                      {this.props.name}
                    </Link>
                  </span>
                )}
                {!this.props.path && <span>{this.props.name}</span>}
              </h2>
            )}
            {this.getIframeHtml()}
            {this.props.defaultText && (
              <p
                className={classNames({
                  iframe_footer: true,
                })}
              >
                {this.props.defaultText}
              </p>
            )}
          </div>
        </InViewObserver>
      </React.Fragment>
    );
  }
}

IFrameWdt.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string,
  src: PropTypes.string.isRequired,
  wu: PropTypes.string,
  dataUrl: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string.isRequired,
  lazyload: PropTypes.string,
  item: PropTypes.shape({ id: PropTypes.string }),
  lazy: PropTypes.bool,
  sendGA: PropTypes.func,
  border: PropTypes.bool,
};

IFrameWdt.defaultProps = {
  id: '',
  name: '',
  className: '',
  lazyload: '0',
  item: undefined,
  lazy: false,
  wu: '',
  dataUrl: '',
  path: '',
  sendGA: null,
  border: false,
};

export default IFrameWdt;
